import { Button } from "@headlessui/react";
import { CSSProperties } from "react";

export const TextButton = ({
  children,
  className,
  onClick,
  otherProps,
  disabled,
  style,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: Function;
  otherProps?: any;
  style?: CSSProperties;
  disabled?: boolean;
}) => (
  <>
    <Button
      className={`py-2 px-8 rounded bg-white text-blue-700 data-[hover]:brightness-125 data-[active]:brightness-125 ${className}`}
      onClick={onClick}
      style={style}
      disabled={disabled}
      {...otherProps}
    >
      {children}
    </Button>
  </>
);
